import { useEffect, useState } from 'react';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Card from '../components/custom/Card';
import CollapseCard from '../components/custom/CollapseCard';
import PageContainer from '../components/custom/PageContainer';
import { apiUrl } from '../config';
import { DisciplineCourseType } from '../redux/actions/disciplineCourseAction';
import { StudentType } from './Student';

import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import { CSVLink } from 'react-csv';
import * as Feather from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import FormInput from '../components/custom/FormInput';
import api, { getAxiosRequestConfig } from '../config/api';
import { AuthUserType } from '../redux/actions/authUserActions';
import { CourseType } from '../redux/actions/courseActions';
import { DegreeType } from '../redux/actions/degreeAction';
import { DisciplineType } from '../redux/actions/disciplineAction';
import { DropDownType } from '../redux/actions/dropDownAction';
import { ExamType } from '../redux/actions/examAction';
import { PhaseType } from '../redux/actions/phaseAction';
import { fetchStudentMarkAction, StudentMarkType } from '../redux/actions/studentMarkAction';
import { StoreState } from '../redux/reducers';
import { AppDispatch } from '../redux/store';
import { FilteredStudentType } from './DummyNoGeneration';
import imgPath from './img/collegeLogo.png';
import { CourseDetails, MarkSheetReportType } from './MarkSheetReport';
import { handleArrear, handleDeleteArrear, handleReArrear, handleUpdateArrear, StudentGrade } from './StudentMarkPractical';

interface StudentArrearType {
    id?: number;
    disciplineId: number;
    degreeId: number;
    registerNo: string;
    semesterNo: number;
    disciplineCourseId: number;
    attemptCount: number;
    clearedSemester: number;
    status: string;
    createdBy: string;
    createTimestamp: string;
}

const calculateGrade = (totalConvertedMark: number, extConvertedMark: number, courseType: string) => {

    if (extConvertedMark < 18 && courseType === 'Practical') {//this check is only for practical
        return 0;
    }

    if (extConvertedMark < 27 && courseType === 'Theory') {//this check is only for theory
        return 0;
    }

    if (totalConvertedMark >= 91 && totalConvertedMark <= 100) {
        return 10;
    } else if (totalConvertedMark >= 81 && totalConvertedMark <= 90) {
        return 9;
    } else if (totalConvertedMark >= 71 && totalConvertedMark <= 80) {
        return 8;
    } else if (totalConvertedMark >= 61 && totalConvertedMark <= 70) {
        return 7;
    } else if (totalConvertedMark >= 56 && totalConvertedMark <= 60) {
        return 6;
    } else if (totalConvertedMark >= 50 && totalConvertedMark <= 55) {
        return 5;
    } else {
        return 0;
    }
};


const calculateGradeText = (totalConvertedMark: number, extConvertedMark: number, courseType: string) => {

    if (extConvertedMark < 18 && courseType === 'Practical') {//this check is only for practical
        return 'U';
    }

    if (extConvertedMark < 27 && courseType === 'Theory') {//this check is only for theory
        return 'U';
    }

    if (totalConvertedMark >= 91 && totalConvertedMark <= 100) {
        return 'O';
    } else if (totalConvertedMark >= 81 && totalConvertedMark <= 90) {
        return 'A+';
    } else if (totalConvertedMark >= 71 && totalConvertedMark <= 80) {
        return 'A';
    } else if (totalConvertedMark >= 61 && totalConvertedMark <= 70) {
        return 'B+';
    } else if (totalConvertedMark >= 56 && totalConvertedMark <= 60) {
        return 'B';
    } else if (totalConvertedMark >= 50 && totalConvertedMark <= 55) {
        return 'C';
    } else {
        return 'U';
    }
};


const StuAssessment = () => {
    const dispatch = useDispatch<AppDispatch>()
    const authUser = useSelector<StoreState, AuthUserType | null>(state => state.authUser)

    const token = authUser?.token!
    const config = getAxiosRequestConfig(token)

    const dropDownList = useSelector<StoreState, DropDownType[]>(state => state.dropDown)
    const studentMarkList = useSelector<StoreState, StudentMarkType[]>(state => state.studentMark)
    const courseList = useSelector<StoreState, CourseType[]>(state => state.course)
    const degreeList = useSelector<StoreState, DegreeType[]>(state => state.degree)
    const disciplineList = useSelector<StoreState, DisciplineType[]>(state => state.discipline)
    const examList = useSelector<StoreState, ExamType[]>(state => state.exam)
    const disciplineCourseList = useSelector<StoreState, DisciplineCourseType[]>(state => state.disciplineCourse)

    const [stuAssessmentList, setStuAssessmentList] = useState<StuAssessmentType[]>([]);
    const [studentarrearList, setStudentArrearList] = useState<StudentArrearType[]>([]);
    const fileName = 'student_assessment';

    const [editFlag, setEditFlag] = useState(false);

    const [id, setId] = useState<number>(0);
    const [createdBy, setCreatedBy] = useState<string>('');
    const [createTimestamp, setCreateTimestamp] = useState<string>('');
    const [showDeleteConfirmation, setShowDeleteConfirmation] = useState(false);

    // const [registerNoError, setRegisterNoError] = useState('');
    // const [disciplineCourseIdError, setDisciplineCourseIdError] = useState('');
    const [markError, setMarkError] = useState('');

    // const [selectCourseId, setSelectCourseId] = useState<CourseType[]>([]);
    // const [selectedRegisterNo, setSelectedRegisterNo] = useState<StudentType[]>([]);
    // const [selectedStudent, setSelectedStudent] = useState<StudentType | null>(null);

    const [stuAssessmentTable, setStuAssessmentTable] = useState<StuAssessmentType[] | StuAssessmentUpdateType[]>([])
    const [markArray, setMarkArray] = useState<string[]>([]);

    // const [disciplineCourseList, setDisciplineCourseList] = useState<DisciplineCourseType[]>([]);

    const [contactHours, setContactHours] = useState<string>('');
    const [attendenceError, setAttendenceError] = useState('');
    const [contactHoursError, setContactHoursError] = useState<string>('');

    const [last10Years, setLast10Years] = useState<number[]>([]);

    //Array insert for attended hours and contact hours
    const [attendenceArray, setAttendenceArray] = useState<string[]>([]);
    const [contactHoursArray, setContactHoursArray] = useState<string[]>([]);

    //for edit Model
    const [editModelShow, setEditModelShow] = useState(false);
    const [editId, setEditId] = useState(0);
    const [editRegisterNo, setEditRegisterNo] = useState('');
    const [editDegreeId, setEditDegreeId] = useState('');
    const [editDegreeName, setEditDegreeName] = useState('');
    const [editDisciplineId, setEditDisciplineId] = useState('');
    const [editDisciplineName, setEditDisciplineName] = useState('');
    const [editDisciplineCourseId, setEditDisciplineCourseId] = useState('');
    const [editCourse, setEditCourse] = useState('');
    const [editbatch, setEditBatch] = useState('');
    const [editContactHours, setEditContactHours] = useState('');
    const [editAttendence, setEditAttendence] = useState('');
    const [editMark, setEditMark] = useState('');
    const [editPhase, setEditPhase] = useState('');
    const [apiErrorMessage, setApiErrorMessage] = useState('');

    //filter view
    const [studentListFilter, setFilteredStudentList] = useState<StuAssessmentType[]>([]);

    const [selectedPhaseIdFilter, setSelectedPhaseIdFilter] = useState('');
    const [selectedCourseIdFilter, setSelectedCourseIdFilter] = useState('');
    const [degreeIdFilter, setDegreeIdFilter] = useState('');
    const [disciplineIdFilter, setDisciplineIdFilter] = useState('');
    const [batchFilter, setBatchFilter] = useState('');
    const [selectedCourseStudents, setSelectedCourseStudents] = useState<FilteredStudentType[]>([])


    const handleMarkChange = (index: number, value: string) => {
        setMarkArray(prevArray => {
            const newArray = [...prevArray];
            newArray[index] = value;
            const parsedValue = parseFloat(value);
            if (isNaN(parsedValue) || parsedValue < -1 || parsedValue > 100) {
                setMarkError('Mark must be a number between -1 and 100');
            } else {
                setMarkError('');
            }
            return newArray;
        });
    }

    // const handelAttendenceChange = (index: number, value: string) => {
    //   setAttendenceArray(prevArray => {
    //     const newArray = [...prevArray];
    //     newArray[index] = value;
    //     return newArray;
    //   });
    // }

    const handelAttendenceChange = (index: number, value: string) => {
        setAttendenceArray((prevArray) => {
            const newArray = [...prevArray];
            newArray[index] = value;
            if (parseFloat(value) > parseFloat(contactHoursArray[index])) {
                setAttendenceError("Attended Hrs can't exceed Contact Hrs");
            } else if (parseFloat(value) < 0) {
                setAttendenceError("Invalid Attended Hrs");
            } else {
                setAttendenceError('');
            }
            return newArray;
        });
    };
    // console.log(attendenceArray);
    // console.log(stuAssessmentTable);

    useEffect(() => {
        const initialContactHoursArray = stuAssessmentTable?.map((sa) => sa.contactHours ? sa.contactHours : contactHours);
        const initialAttendenceHoursArray = stuAssessmentTable?.map((sa) => sa.attendedHours ? sa.attendedHours : '');
        const initialMarksArray = stuAssessmentTable?.map((sa) => sa.mark ? sa.mark : '');
        setContactHoursArray(initialContactHoursArray);
        setAttendenceArray(initialAttendenceHoursArray)
        setMarkArray(initialMarksArray)
    }, [contactHours, stuAssessmentTable]);


    const handelContactHoursChange = (index: number, value: string) => {
        setContactHoursArray((prevArray) => {
            const newArray = [...prevArray];
            newArray[index] = value;
            return newArray;
        });
    };

    useEffect(() => {
        const currentYear = new Date().getFullYear();
        const years = Array.from({ length: 10 }, (_, index) => currentYear - index);
        setLast10Years(years);
    }, []);


    //degree filter 
    // const [selectedDegree, setSelectedDegree] = useState<Degree[]>([]);
    const [selectedDegreeId, setSelectedDegreeId] = useState('');
    const [degreeIdError, setDegreeIdError] = useState('');
    const [courseType, setCourseType] = useState('');
    const [courseTypeError, setCourseTypeError] = useState('');
    const [sem, setSem] = useState<string>('')//for stud mark update
    const [semError, setSemError] = useState<string>('')
    const [exam, setExam] = useState<string>('')//for stud mark update
    const [examError, setExamError] = useState<string>('')

    // useEffect(() => {
    //     api.get(`${apiUrl}/degree/`)
    //         .then((response) => {
    //             setSelectedDegree(response.data.data);
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching discipline course', error);
    //         });
    // }, [])

    //discipline filter
    // const [selectedDiscipline, setSelectedDiscipline] = useState<Discipline[]>([]);
    const [selectedDisciplineId, setSelectedDisciplineId] = useState('');
    const [disciplineIdError, setDisciplineIdError] = useState('');

    // useEffect(() => {
    //     api.get(`${apiUrl}/discipline/`)
    //         .then((response) => {
    //             setSelectedDiscipline(response.data.data);
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching discipline course', error);
    //         });
    // }, [])

    //filter for course
    // const [selectedCourse, setSelectedCourse] = useState<Course[]>([]);
    const [selectedCourseId, setSelectedCourseId] = useState('');
    const [courseIdError, setCourseIdError] = useState('');

    // useEffect(() => {
    //     api.get(`${apiUrl}/course/`)
    //         .then((response) => {
    //             setSelectedCourse(response.data.data);
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching course', error);
    //         });
    // }, []);

    //phase filter 
    const [selectedPhase, setSelectedPhase] = useState<PhaseType[]>([]);
    const [selectedPhaseId, setSelectedPhaseId] = useState('');
    const [phaseIdError, setPhaseIdError] = useState('');

    useEffect(() => {
        api.get(`${apiUrl}/phase/`)
            .then((response) => {
                setSelectedPhase(response.data.data);
            })
            .catch((error) => {
                console.error('Error fetching phase', error);
            });
    }, []);

    //batch filter
    const [selectedBatch, setSelectedBatch] = useState<StudentType[]>([]);
    const [selectedBatchId, setSelectedBatchId] = useState('');
    const [batchIdError, setBatchIdError] = useState('');

    useEffect(() => {
        api.get(`${apiUrl}/student/`, config)
            .then((response) => {
                setSelectedBatch(response.data.data);
            })
            .catch((error) => {
                console.error('Error fetching student', error);
            });
    }, []);

    // useEffect(() => {
    //     api.get(`${apiUrl}/disciplineCourse/`, config)
    //         .then((response) => {
    //             setDisciplineCourseList(response.data.data);
    //         })
    //         .catch((error) => {
    //             console.error('Error fetching Discipline Course', error);
    //         });
    // }, []);

    useEffect(() => {
        api.get(`${apiUrl}/studentarrear/`, config)
            .then((response) => {
                setStudentArrearList(response.data.data);
            })
            .catch((error) => {
                console.error('Error fetching student arrear', error);
            });
    }, [])

    // const filterStudent = () => {
    //     if (
    //         selectedDegreeId !== '' &&
    //         selectedDisciplineId !== '' &&
    //         selectedCourseId !== '' &&
    //         selectedPhaseId !== '' &&
    //         selectedBatchId !== '' &&
    //         contactHours !== ''
    //     ) {
    //         api
    //             .get<{ data: StuAssessmentType[] }>(`${apiUrl}/studentAssessment/?degreeId=${selectedDegreeId}&disciplineId=${selectedDisciplineId}&batch=${selectedBatchId}&courseId=${selectedCourseId}`)
    //             .then((response) => {
    //                 setStuAssessmentTable(response.data.data || []);
    //                 console.log(response.data.data);
    //             })
    //             .catch((error) => console.log(error));
    //     } else {
    //         toast.error('Please select all filters');
    //     }
    // };

    const CheckIfDataExists = (data: StuAssessmentType[], stuAssessmentRecords: StuAssessmentType[]) => {
        let UpdatedRecord: StuAssessmentUpdateType[] = []
        // console.log('out');

        if (data.length > 0 && stuAssessmentRecords.length > 0) {
            // console.log('in');

            data.forEach(d => {
                let disciplineCourseId = disciplineCourseList?.find(dc => dc.degreeId.toString() === selectedDegreeId.toString() && dc.disciplineId.toString() === selectedDisciplineId.toString() && dc.courseId.toString() === selectedCourseId.toString() && dc.courseType === courseType)?.id

                let record = stuAssessmentRecords.find(f => f.registerNo?.toString() === d.registerNo?.toString() && f.degreeId.toString() === selectedDegreeId.toString() && f.disciplineId.toString() === selectedDisciplineId.toString() && f.phase?.toString() === selectedPhaseId.toString() && f.batch?.toString() === selectedBatchId?.toString() && f.disciplineCourseId?.toString() === disciplineCourseId?.toString() && f.courseType.toString() === courseType.toString())


                if (record) {

                    console.log('in1');
                    UpdatedRecord.push(
                        {
                            registerNo: record.registerNo,
                            contactHours: record.contactHours,
                            attendedHours: record.attendedHours,
                            mark: record.mark,
                            externalMaxMark: d.externalMaxMark
                        }
                    )
                } else {
                    console.log('in2');
                    UpdatedRecord.push({
                        registerNo: d.registerNo,
                        externalMaxMark: d.externalMaxMark
                    })
                }
            })
            return UpdatedRecord
        } else return data

    }

    const filterStudent = () => {
        if (
            selectedDegreeId !== '' &&
            selectedDisciplineId !== '' &&
            selectedCourseId !== '' &&
            selectedPhaseId !== '' &&
            selectedBatchId !== '' &&
            courseType !== '' &&
            exam !== '' &&
            sem !== '' &&
            contactHours !== ''
        ) {
            // fetchData(selectedDegreeId, selectedDisciplineId, selectedPhaseId, selectedBatchId, selectedCourseId)
            let disciplineCourseIdFilter = disciplineCourseList?.filter(dc => dc.degreeId.toString() === selectedDegreeId.toString() && dc.disciplineId.toString() === selectedDisciplineId.toString() && dc.courseId.toString() === selectedCourseId.toString()).map(f => f.id)

            // api.get<{ error: any; message: any; data: StuAssessmentType[] }>(
            //     `${apiUrl}/studentAssessment/?phase=${selectedPhaseId}&degreeId=${selectedDegreeId}&disciplineId=${selectedDisciplineId}&disciplineCourseId=${selectedCourseId}&batch=${selectedBatchId}`, config)
            api.get<{ error: any; message: any; data: StuAssessmentType[] }>(`${apiUrl}/studentAssessment/viewFilter/?degreeId=${selectedDegreeId}&disciplineId=${selectedDisciplineId}&disciplineCourseId=${disciplineCourseIdFilter.join(",")}&phaseId=${selectedPhaseId}&batch=${selectedBatchId}`, config)

                .then((response) => {
                    const ExistingData = response.data.data || []
                    if (response.status === 200) {
                        api.get<{ data: StuAssessmentType[] }>(
                            `${apiUrl}/studentAssessment/?degreeId=${selectedDegreeId}&disciplineId=${selectedDisciplineId}&batch=${selectedBatchId}&courseId=${selectedCourseId}&courseType=${courseType}`, config
                        ).then((response) => {
                            if (response.status === 200) {
                                const result = response.data.data
                                // setStuAssessmentTable(response.data.data);
                                console.log(response.data.data);
                                let updatedData = CheckIfDataExists(result, ExistingData)
                                setStuAssessmentTable(updatedData);
                                setMarkError('')
                                setAttendenceError('')
                                // console.log(response.data.data);
                            }
                        });
                    } else {
                        toast.error(response.data.message);
                    }
                })
                .catch((error) => {
                    toast.error(error.response.data.message);
                });
        } else {
            toast.error('Please select all filters');
        }
    };

    // useEffect(() => {
    //     fetchData();
    // }, [selectedPhaseIdFilter, degreeIdFilter, disciplineIdFilter, selectedCourseIdFilter, batchFilter]);

    // disCourseId = disciplineCourseList.find(f => f.id?.toString() === selectedCourseIdFilter)?.courseId;

    const getDisciplineCourseId = (selectedCourseId: number) => {
        // console.log(selectedCourseId);
        return disciplineCourseList.find(f => f.id === selectedCourseId)?.courseId;
    };

    useEffect(() => {
        // fetchData();
        dispatch(fetchStudentMarkAction());
    }, [])

    const fetchData = (degreeIdFilter: string, disciplineIdFilter: string, selectedPhaseIdFilter: string, batchFilter: string, selectedCourseIdFilter: string) => {
        if (degreeIdFilter !== '' &&
            disciplineIdFilter !== '' &&
            selectedPhaseIdFilter !== '' &&
            batchFilter !== '') {

            let disciplineCourseIdFilter = disciplineCourseList?.filter(dc => dc.degreeId.toString() === degreeIdFilter.toString() && dc.disciplineId.toString() === disciplineIdFilter.toString() && dc.courseId.toString() === selectedCourseIdFilter.toString()).map(f => f.id)

            api.get<{ data: StuAssessmentType[] }>(`${apiUrl}/studentAssessment/viewFilter/?degreeId=${degreeIdFilter}&disciplineId=${disciplineIdFilter}&disciplineCourseId=${disciplineCourseIdFilter.join(",")}&phaseId=${selectedPhaseIdFilter}&batch=${batchFilter}`, config)
                .then((response) => {
                    if (response.status === 200) {

                        // console.log(response.data.data);
                        setStuAssessmentList(response.data.data);
                        setFilteredStudentList(response.data.data)
                    } else {
                        setStuAssessmentList([]);
                        setFilteredStudentList([])
                    }

                    // const filteredStudents = response.data.data.filter((student) => {

                    //     return (
                    //         (selectedPhaseIdFilter === '' || student.phase.toString() === selectedPhaseIdFilter) &&
                    //         (degreeIdFilter === '' || student.degreeId.toString() === degreeIdFilter) &&
                    //         (disciplineIdFilter === '' || student.disciplineId.toString() === disciplineIdFilter) &&
                    //         (selectedCourseIdFilter === '' || getDisciplineCourseId(parseInt(student.disciplineCourseId)) === parseInt(selectedCourseIdFilter)) &&
                    //         // (selectedCourseIdFilter === '' || getDisciplineCourseId(student.disciplineCourseId).includes(parseInt(selectedCourseIdFilter))) &&
                    //         (batchFilter === '' || student.batch.toString() === batchFilter)
                    //     );
                    // });

                    // const checkFilteredStudents = selectedPhaseIdFilter !== '' || degreeIdFilter !== '' || disciplineIdFilter !== '' || selectedCourseIdFilter !== '' || batchFilter !== ''
                    //     ? filteredStudents
                    //     : response.data.data;

                    // setFilteredStudentList(checkFilteredStudents);
                })
                .catch((error) => console.log(error));
        } else {
            toast.error('Pleasee select all filters');
        }

    };

    const resetData = () => {
        setStuAssessmentList([])
        setFilteredStudentList([])
        setSelectedPhaseIdFilter('')
        setDegreeIdFilter('')
        setDisciplineIdFilter('')
        setSelectedCourseIdFilter('')
        setBatchFilter('')
        setCourseType('')
        fetchData(degreeIdFilter, disciplineIdFilter, selectedPhaseIdFilter, batchFilter, selectedCourseIdFilter);
    }

    const handleFetchDataForMarksheetAndUpdateStudentGrades = (exam: string, degree: string, discipline: string, selectedBatchId: string, semester: string, registeNo?: string) => {
        if (exam !== '' && degree !== '' && discipline !== '' && selectedBatchId !== '' && semester !== '') {
            // let years = academicYear.split('-')
            api.get<{ data: MarkSheetReportType[] }>(`${apiUrl}/student/marksheet/?degreeId=${degree}&disciplineId=${discipline}&examId=${exam}&batch=${selectedBatchId}&sem=${semester}`, config).then(async (response) => {
                if (response.status === 200 && response.data.data) {
                    const result = response.data.data;
                    const AddGradeData: StudentGrade[] = [];
                    // setMarksheetData(response.data.data);
                    let totalCreditsRegistered = 0;
                    let totalCreditsEarned = 0;
                    let totalGradePointsEarned = 0;
                    let GPA = 0;
                    let cumulativeCredits = 0;
                    let sem = 0;

                    result.length > 0 && result?.filter(f => registeNo !== undefined ? f.registerNo?.toString() === registeNo?.toString() : f)?.forEach(h => {
                        //
                        const groupedCourses = h?.courseDetails?.reduce((acc: { [key: string]: CourseDetails }, course: CourseDetails) => {
                            if (!acc[course.courseCode]) {
                                acc[course.courseCode] = { ...course, extMark: course.extMark };
                            } else {
                                // acc[course.courseCode].credit! += course.credit;

                                // acc[course.courseCode].extMark! += course.extMark;
                                // console.log();

                                // acc[course.courseCode].unvGrade! = calculateGrade(Math.round(acc[course.courseCode].extMark / 2), Math.round(acc[course.courseCode].extMark / 2), 'Theory Cum Practical');

                                // acc[course.courseCode].unvGradeText! = calculateGradeText(Math.round(acc[course.courseCode].extMark / 2), Math.round(acc[course.courseCode].extMark / 2), 'Theory Cum Practical');
                                //

                                acc[course.courseCode].credit! += course.credit;
                                if (course.courseType === 'Theory') {
                                    acc[course.courseCode].unvGrade! = course.unvGrade;
                                    acc[course.courseCode].unvGradeText! = course.unvGradeText;
                                }
                            }
                            return acc;
                        }, {} as { [key: string]: CourseDetails });
                        //
                        console.log('groupedCourses:', groupedCourses);

                        Object.values(groupedCourses)?.forEach(cd => {
                            // h?.courseDetails?.forEach(cd => {
                            sem = cd.sem;
                            totalCreditsRegistered += parseInt(cd.credit)
                            totalGradePointsEarned += (cd.unvGrade)
                            if (cd.unvGrade > 0) {
                                totalCreditsEarned += parseInt(cd.credit)
                                cumulativeCredits += parseInt(cd.credit)
                                GPA += (cd.unvGrade) * parseInt(cd.credit)
                            }
                        })
                        GPA = GPA / totalCreditsEarned;
                        let obj = {
                            registeNo: h.registerNo,
                            batch: selectedBatchId.toString(),
                            sem: sem,
                            cRegistered: totalCreditsRegistered.toString(),
                            cEarned: totalCreditsEarned.toString(),
                            gpEarned: totalGradePointsEarned.toString(),
                            gpAverage: GPA.toFixed(2),
                        }

                        AddGradeData.push(obj)
                    });
                    console.log(AddGradeData);

                    if (AddGradeData) {
                        await api.post(`${apiUrl}/studentGrade/bulkInsert/`, AddGradeData).then((response) => {
                            if (response.status === 200) {
                                toast.success('Grades Updated');
                                // dispatch(fetchStudentMarkAction());
                                // resetStates();
                                // handleDownloadPDF(editData);
                                clearHandler();
                            }
                        }).catch((error) => {
                            if (error!.response) {
                                toast.error(error.response.data.message);
                            }
                        });
                    }

                }
            }).catch((error) => {
                console.error('Error fetching marksheet data', error);
            });
        } else {
            toast.error('Select All Filters', { position: 'top-right', autoClose: 3000 });
            // setMarksheetData([])
        }
    }

    const UpdateStudentMarksAsPerInternalsForAdd = async (exam: string, selectedDegreeId: string, selectedDisciplineId: string, selectedBatchId: string, sem: string, selectedCourseId: string) => {
        if (exam !== '' && selectedDegreeId !== '' && selectedDisciplineId !== '' && selectedBatchId !== '' && sem !== '' && selectedCourseId !== '') {
            console.log('ADD');

            let disCourseObj = disciplineCourseList?.find(f => f.degreeId?.toString() === selectedDegreeId?.toString() && f.disciplineId?.toString() === selectedDisciplineId?.toString() && f.courseId?.toString() === selectedCourseId?.toString() && f.courseType === courseType)

            let disciplineCourseId = disciplineCourseList?.find(f => f.degreeId?.toString() === selectedDegreeId?.toString() && f.disciplineId?.toString() === selectedDisciplineId?.toString() && f.courseId?.toString() === selectedCourseId?.toString() && f.courseType === courseType)?.id

            const StudMarkRecords = studentMarkList?.filter(sm => sm.degreeId?.toString() === selectedDegreeId?.toString() && sm.disciplineId?.toString() === selectedDisciplineId?.toString() && sm.disciplineCourseId?.toString() === disciplineCourseId?.toString() && sm.examId?.toString() === exam?.toString() && sm.batch?.toString() === selectedBatchId?.toString() && sm.semester?.toString() === (sem)?.toString() && sm.gradeText !== '' && sm.unvGradeText !== '')
            console.log((editId?.toString() === '' && editDisciplineCourseId === ''));
            console.log(editDisciplineCourseId);
            console.log(disciplineCourseId);
            console.log(studentMarkList);
            console.log(StudMarkRecords);

            if (StudMarkRecords.length > 0) {
                let error = false;
                const editData: any = [];

                await api.get<{ data: FilteredStudentType[] }>(`${apiUrl}/student/dummyNoGeneration/?degreeId=${selectedDegreeId}&disciplineId=${selectedDisciplineId}&batch=${selectedBatchId}&disciplineCourseId=${disciplineCourseId}&sem=${sem}&examId=${exam}`, config)
                    .then((response) => {
                        const result = response.data.data
                        if (result.length > 0) {
                            setSelectedCourseStudents(result);
                            StudMarkRecords?.forEach(sm => {

                                let selectedRecord = result?.find(f => f.registerNo === sm.registerNumber)
                                if (selectedRecord) {
                                    const extConversion = disCourseObj?.extConversion ? disCourseObj.extConversion : 0;
                                    const convertedExternalMark = sm.extMark === -1 ? 0 : Math.round((sm.extMark! / 100) * extConversion);

                                    const intMark = selectedRecord?.internalMark ? parseInt(selectedRecord?.internalMark) : 0;
                                    const intConvertedMark = ((selectedRecord?.internalMark ? parseInt(selectedRecord?.internalMark) : 0) / 100) * (selectedRecord?.intConversionRate ? parseInt(selectedRecord?.intConversionRate) : 0);
                                    const totalConversion = Math.round(intConvertedMark + convertedExternalMark);
                                    // console.log('Int', intMark);
                                    // console.log('Intcon', intConvertedMark);

                                    const grade = calculateGrade(totalConversion, convertedExternalMark, courseType);
                                    const gradeText = calculateGradeText(totalConversion, convertedExternalMark, courseType);


                                    editData.push({
                                        id: sm.id,
                                        intMark: intMark,
                                        intConvertedMark: intConvertedMark,
                                        extMark: sm.extMark,
                                        extConvertedMark: convertedExternalMark,
                                        totConvertedMark: totalConversion,
                                        grade: grade,
                                        gradeText: gradeText,
                                        disciplineCourseId: disciplineCourseId,
                                        degreeId: parseInt(selectedDegreeId),
                                        disciplineId: parseInt(selectedDisciplineId),
                                        semester: parseInt(sem),
                                        registerNumber: sm.registerNumber,
                                        // name: sm.name
                                    });
                                } else {
                                    console.log('No selected student data found');
                                    // clearHandler();
                                }
                            })
                        } else {
                            // setSelectedCourseStudents([])
                            // setDummyNoGenData([])
                        }
                    })
                    .catch((error) => {
                        toast.error(error);
                        console.error('Error fetching students', error);
                    });
                // console.log(selectedCourseStudents);

                if (!error) {
                    try {
                        if (editData.length > 0) {
                            // console.log("Hai I am put")
                            await api.put(`${apiUrl}/studentMark/bulkUpdateForPractical/`, editData).then((response) => {
                                if (response.status === 200 && response.data.data) {
                                    handleFetchDataForMarksheetAndUpdateStudentGrades(exam, selectedDegreeId, selectedDisciplineId, selectedBatchId, sem)
                                    toast.success(response.data.message);
                                    dispatch(fetchStudentMarkAction());
                                    // handleDownloadPDF(editData);
                                    // resetStates();
                                }
                            }).catch((error) => {
                                if (error!.response) {
                                    toast.error(error.response.data.message);
                                }
                            });

                            for (let i = 0; i < editData.length; i++) {
                                const editItem = editData[i];

                                let getSemesterForCheck = studentarrearList.find(sa =>
                                    sa.disciplineId === editItem.disciplineId &&
                                    sa.degreeId === editItem.degreeId &&
                                    sa.disciplineCourseId === editItem.disciplineCourseId &&
                                    sa.registerNo === editItem.registerNumber &&
                                    sa.semesterNo === parseInt(sem)
                                )?.semesterNo || 0;

                                let getSemesterFromDisCourse = disciplineCourseList.find(dc => dc.id === editItem.disciplineCourseId)?.semesterNo;

                                if (editItem.grade === 0 && editItem.gradeText === 'U' && getSemesterFromDisCourse === parseInt(sem)) {
                                    await handleArrear(editItem, parseInt(sem));
                                } else if (editItem.grade > 0 && editItem.gradeText !== 'U' && getSemesterForCheck === parseInt(sem)) {
                                    console.log('Delete')
                                    await handleDeleteArrear(editItem, parseInt(sem), studentarrearList);
                                } else if (editItem.grade && editItem.grade > 0 && editItem.gradeText !== 'U' && getSemesterForCheck === 0) {
                                    await handleUpdateArrear(editItem, parseInt(sem), studentarrearList);
                                } else if (editItem.grade === 0 && editItem.gradeText === 'U' && getSemesterForCheck === 0) {
                                    await handleReArrear(editItem, parseInt(sem), studentarrearList);
                                }
                            }
                        }
                    } catch (error: any) {
                        if (error.response) {
                            console.error("Error:", error.response.data);
                            toast.error(error.response.data.message);
                        } else {
                            console.error("Error:", error);
                            toast.error("An error occurred while updating/creating the student mark.");
                        }
                    }
                }
            } else {
                console.log('No studentmark records found');
                clearHandler();
            }


        } else {
            toast.error('Select All Filters', { position: 'top-right', autoClose: 3000 });

            setSelectedCourseStudents([])
            // setDummyNoGenData([])
        }
    }

    const UpdateStudentMarksAsPerInternalsForAssEdit = async (exam: string, selectedDegreeId: string, selectedDisciplineId: string, selectedBatchId: string, sem: string, selectedCourseId: string, registerNo: string) => {
        if (exam !== '' && selectedDegreeId !== '' && selectedDisciplineId !== '' && selectedBatchId !== '' && sem !== '' && selectedCourseId !== '' && registerNo !== '' && editDisciplineCourseId !== '') {

            // let disCourseObj = (editId?.toString() === '' && editDisciplineCourseId === '')
            //     ? disciplineCourseList.find(f => f.degreeId?.toString() === selectedDegreeId && f.disciplineId?.toString() === selectedDisciplineId && f.courseId?.toString() === selectedCourseId && f.courseType === courseType)
            //     : disciplineCourseList.find(f => f.id === parseInt(editDisciplineCourseId))

            // let disciplineCourseId = (editId?.toString() === '' && editDisciplineCourseId === '')
            //     ? disciplineCourseList.find(f => f.degreeId?.toString() === selectedDegreeId && f.disciplineId?.toString() === selectedDisciplineId && f.courseId?.toString() === selectedCourseId && f.courseType === courseType)?.id
            //     : parseInt(editDisciplineCourseId)
            let disCourseObj = disciplineCourseList.find(f => f.id === parseInt(editDisciplineCourseId))
            let disciplineCourseId = parseInt(editDisciplineCourseId)

            const StudMarkRecords = studentMarkList?.filter(sm => sm.degreeId === parseInt(selectedDegreeId) && sm.disciplineId === parseInt(selectedDisciplineId) && sm.disciplineCourseId === disciplineCourseId && sm.examId === parseInt(exam) && sm.batch === selectedBatchId && sm.semester === parseInt(sem) && sm.gradeText !== '' && sm.unvGradeText !== '' && sm.registerNumber === registerNo)

            if (StudMarkRecords.length > 0) {
                let error = false;
                const editData: any = [];

                await api.get<{ data: FilteredStudentType[] }>(`${apiUrl}/student/dummyNoGeneration/?degreeId=${selectedDegreeId}&disciplineId=${selectedDisciplineId}&batch=${selectedBatchId}&disciplineCourseId=${disciplineCourseId}&sem=${sem}&examId=${exam}`, config)
                    .then((response) => {
                        const result = response.data.data
                        if (result.length > 0) {
                            setSelectedCourseStudents(result);
                            StudMarkRecords?.forEach(sm => {

                                let selectedRecord = result?.find(f => f.registerNo === sm.registerNumber)
                                if (selectedRecord) {
                                    const extConversion = disCourseObj?.extConversion ? disCourseObj.extConversion : 0;
                                    const convertedExternalMark = sm.extMark === -1 ? 0 : Math.round((sm.extMark! / 100) * extConversion);

                                    const intMark = selectedRecord?.internalMark ? parseInt(selectedRecord?.internalMark) : 0;
                                    const intConvertedMark = ((selectedRecord?.internalMark ? parseInt(selectedRecord?.internalMark) : 0) / 100) * (selectedRecord?.intConversionRate ? parseInt(selectedRecord?.intConversionRate) : 0);
                                    const totalConversion = Math.round(intConvertedMark + convertedExternalMark);
                                    // console.log('Int', intMark);
                                    // console.log('Intcon', intConvertedMark);

                                    const grade = calculateGrade(totalConversion, convertedExternalMark, courseType);
                                    const gradeText = calculateGradeText(totalConversion, convertedExternalMark, courseType);


                                    editData.push({
                                        id: sm.id,
                                        intMark: intMark,
                                        intConvertedMark: intConvertedMark,
                                        extMark: sm.extMark,
                                        extConvertedMark: convertedExternalMark,
                                        totConvertedMark: totalConversion,
                                        grade: grade,
                                        gradeText: gradeText,
                                        disciplineCourseId: disciplineCourseId,
                                        degreeId: parseInt(selectedDegreeId),
                                        disciplineId: parseInt(selectedDisciplineId),
                                        semester: parseInt(sem),
                                        registerNumber: sm.registerNumber,
                                        // name: sm.name
                                    });
                                } else {
                                    console.log('No selected student data found');
                                    // clearHandler();
                                }
                            })
                        } else {
                            // setSelectedCourseStudents([])
                            // setDummyNoGenData([])
                        }
                    })
                    .catch((error) => {
                        toast.error(error);
                        console.error('Error fetching students', error);
                    });
                // console.log(selectedCourseStudents);

                if (!error) {
                    try {
                        if (editData.length > 0) {
                            // console.log("Hai I am put")
                            await api.put(`${apiUrl}/studentMark/bulkUpdateForPractical/`, editData).then((response) => {
                                if (response.status === 200 && response.data.data) {
                                    handleFetchDataForMarksheetAndUpdateStudentGrades(exam, selectedDegreeId, selectedDisciplineId, selectedBatchId, sem, registerNo)
                                    toast.success(response.data.message);
                                    dispatch(fetchStudentMarkAction());
                                    // handleDownloadPDF(editData);
                                    // resetStates();
                                }
                            }).catch((error) => {
                                if (error!.response) {
                                    toast.error(error.response.data.message);
                                }
                            });

                            for (let i = 0; i < editData.length; i++) {
                                const editItem = editData[i];

                                let getSemesterForCheck = studentarrearList.find(sa =>
                                    sa.disciplineId === editItem.disciplineId &&
                                    sa.degreeId === editItem.degreeId &&
                                    sa.disciplineCourseId === editItem.disciplineCourseId &&
                                    sa.registerNo === editItem.registerNumber &&
                                    sa.semesterNo === parseInt(sem)
                                )?.semesterNo || 0;

                                let getSemesterFromDisCourse = disciplineCourseList.find(dc => dc.id === editItem.disciplineCourseId)?.semesterNo;

                                if (editItem.grade === 0 && editItem.gradeText === 'U' && getSemesterFromDisCourse === parseInt(sem)) {
                                    await handleArrear(editItem, parseInt(sem));
                                } else if (editItem.grade > 0 && editItem.gradeText !== 'U' && getSemesterForCheck === parseInt(sem)) {
                                    // console.log('Delete')
                                    await handleDeleteArrear(editItem, parseInt(sem), studentarrearList);
                                } else if (editItem.grade && editItem.grade > 0 && editItem.gradeText !== 'U' && getSemesterForCheck === 0) {
                                    await handleUpdateArrear(editItem, parseInt(sem), studentarrearList);
                                } else if (editItem.grade === 0 && editItem.gradeText === 'U' && getSemesterForCheck === 0) {
                                    await handleReArrear(editItem, parseInt(sem), studentarrearList);
                                }
                            }
                        }
                    } catch (error: any) {
                        if (error.response) {
                            console.error("Error:", error.response.data);
                            toast.error(error.response.data.message);
                        } else {
                            console.error("Error:", error);
                            toast.error("An error occurred while updating/creating the student mark.");
                        }
                    }
                }
            } else {
                console.log('No studentmark records found');
                clearHandler();
            }


        } else {
            toast.error('Select All Filters', { position: 'top-right', autoClose: 3000 });

            setSelectedCourseStudents([])
            // setDummyNoGenData([])
        }
    }

    const UpdateStudentMarksAsPerInternalsForAssDlelete = async (exam: string, selectedDegreeId: string, selectedDisciplineId: string, selectedBatchId: string, sem: string, selectedCourseId: string, registerNo: string) => {
        if (exam !== '' && selectedDegreeId !== '' && selectedDisciplineId !== '' && selectedBatchId !== '' && sem !== '' && selectedCourseId !== '' && registerNo !== '' && editDisciplineCourseId !== '') {

            let disCourseObj = disciplineCourseList.find(f => f.id === parseInt(editDisciplineCourseId))
            let disciplineCourseId = parseInt(editDisciplineCourseId)

            const StudMarkRecords = studentMarkList?.filter(sm => sm.degreeId === parseInt(selectedDegreeId) && sm.disciplineId === parseInt(selectedDisciplineId) && sm.disciplineCourseId === disciplineCourseId && sm.examId === parseInt(exam) && sm.batch === selectedBatchId && sm.semester === parseInt(sem) && sm.gradeText !== '' && sm.unvGradeText !== '' && sm.registerNumber === registerNo)

            if (StudMarkRecords.length > 0) {
                let error = false;
                const editData: any = [];

                // console.log(selectedCourseStudents);

                StudMarkRecords?.forEach(sm => {

                    // let selectedRecord = result?.find(f => f.registerNo === sm.registerNumber)
                    // if (selectedRecord) {
                    const extConversion = disCourseObj?.extConversion ? disCourseObj.extConversion : 0;
                    const convertedExternalMark = sm.extMark === -1 ? 0 : Math.round((sm.extMark! / 100) * extConversion);

                    const intMark = 0;
                    const intConvertedMark = 0;
                    const totalConversion = Math.round(intConvertedMark + convertedExternalMark);
                    // console.log('Int', intMark);
                    // console.log('Intcon', intConvertedMark);

                    const grade = calculateGrade(totalConversion, convertedExternalMark, courseType);
                    const gradeText = calculateGradeText(totalConversion, convertedExternalMark, courseType);


                    editData.push({
                        id: sm.id,
                        intMark: intMark,
                        intConvertedMark: intConvertedMark,
                        extMark: sm.extMark,
                        extConvertedMark: convertedExternalMark,
                        totConvertedMark: totalConversion,
                        grade: grade,
                        gradeText: gradeText,
                        disciplineCourseId: disciplineCourseId,
                        degreeId: parseInt(selectedDegreeId),
                        disciplineId: parseInt(selectedDisciplineId),
                        semester: parseInt(sem),
                        registerNumber: sm.registerNumber,
                        // name: sm.name
                    });
                    // } else {
                    //     console.log('No selected student data found');
                    //     // clearHandler();
                    // }
                })

                if (!error) {
                    try {
                        if (editData.length > 0) {
                            // console.log("Hai I am put")
                            await api.put(`${apiUrl}/studentMark/bulkUpdateForPractical/`, editData).then((response) => {
                                if (response.status === 200 && response.data.data) {
                                    handleFetchDataForMarksheetAndUpdateStudentGrades(exam, selectedDegreeId, selectedDisciplineId, selectedBatchId, sem, registerNo)
                                    toast.success(response.data.message);
                                    dispatch(fetchStudentMarkAction());
                                    // handleDownloadPDF(editData);
                                    // resetStates();
                                }
                            }).catch((error) => {
                                if (error!.response) {
                                    toast.error(error.response.data.message);
                                }
                            });

                            for (let i = 0; i < editData.length; i++) {
                                const editItem = editData[i];

                                let getSemesterForCheck = studentarrearList.find(sa =>
                                    sa.disciplineId === editItem.disciplineId &&
                                    sa.degreeId === editItem.degreeId &&
                                    sa.disciplineCourseId === editItem.disciplineCourseId &&
                                    sa.registerNo === editItem.registerNumber &&
                                    sa.semesterNo === parseInt(sem)
                                )?.semesterNo || 0;

                                let getSemesterFromDisCourse = disciplineCourseList.find(dc => dc.id === editItem.disciplineCourseId)?.semesterNo;

                                if (editItem.grade === 0 && editItem.gradeText === 'U' && getSemesterFromDisCourse === parseInt(sem)) {
                                    await handleArrear(editItem, parseInt(sem));
                                } else if (editItem.grade > 0 && editItem.gradeText !== 'U' && getSemesterForCheck === parseInt(sem)) {
                                    console.log('Delete')
                                    await handleDeleteArrear(editItem, parseInt(sem), studentarrearList);
                                } else if (editItem.grade && editItem.grade > 0 && editItem.gradeText !== 'U' && getSemesterForCheck === 0) {
                                    await handleUpdateArrear(editItem, parseInt(sem), studentarrearList);
                                } else if (editItem.grade === 0 && editItem.gradeText === 'U' && getSemesterForCheck === 0) {
                                    await handleReArrear(editItem, parseInt(sem), studentarrearList);
                                }
                            }
                        }
                    } catch (error: any) {
                        if (error.response) {
                            console.error("Error:", error.response.data);
                            toast.error(error.response.data.message);
                        } else {
                            console.error("Error:", error);
                            toast.error("An error occurred while updating/creating the student mark.");
                        }
                    }
                }
            } else {
                console.log('No studentmark records found');
                clearHandler();
            }


        } else {
            toast.error('Select All Filters', { position: 'top-right', autoClose: 3000 });

            setSelectedCourseStudents([])
            // setDummyNoGenData([])
        }
    }

    const addHandler = () => {
        let error = false

        if (selectedCourseId.length === 0) {
            setCourseIdError('Discipline Course  is required');
            error = true;
        }
        if (selectedCourseId.length > 11) {
            setCourseIdError('Course  must be within 11 characters');
            error = true;
        }
        if (selectedPhaseId.length === 0) {
            setPhaseIdError('Phase  is required');
            error = true;
        }
        if (selectedPhaseId.length > 11) {
            setPhaseIdError('Phase  must be within 11 characters');
            error = true;
        }

        if (contactHours.length === 0) {
            setContactHoursError('Contact Hours is required');
            error = true;
        }
        if (contactHours.length > 11) {
            setContactHoursError('Contact Hours must be within 11 characters');
            error = true;
        }

        if (stuAssessmentTable.length === 0) {
            toast.error('No records to add. Please use the filters to fetch records.');
            error = true;
        }

        const hasErrors = stuAssessmentTable.some((exam, index) => {
            if (contactHoursArray[index]?.toString() === '') {
                setContactHoursError(`Contact Hours is required`);
                return true;
            } else if (attendenceArray[index]?.toString() === '') {
                setAttendenceError(`Attended Hours is required`);
                return true;
            } else if (markArray[index]?.toString() === '') {
                setMarkError(`Mark is required`);
                return true;
            }
            return false;
        });

        const getDisciplineCourseId = (degreeId: string, disciplineId: string, courseId: string) => {
            const selectedCourseIdInt = parseInt(courseId);
            const selectedDisciplineIdInt = parseInt(disciplineId);
            const selectedDegreeIdInt = parseInt(degreeId);
            const course = courseList?.find((c) => c.id === selectedCourseIdInt);
            const discipline = disciplineList?.find((c) => c.id === selectedDisciplineIdInt);
            const degree = degreeList?.find((c) => c.id === selectedDegreeIdInt);
            if (course && discipline && degree) {
                // console.log(course);
                const foundCourse = disciplineCourseList?.find((disciplineCourse) => disciplineCourse.courseId === course.id && disciplineCourse.disciplineId === discipline.id && disciplineCourse.degreeId === degree.id && disciplineCourse.courseType === courseType);
                if (foundCourse) {
                    return foundCourse.id;
                }
            }
            return 'N/A';
        };

        stuAssessmentTable.forEach((Data, index) => {
            if (markArray[index] === '') {
                toast.error(`Mark required in Line ${index + 1}`);
                error = true;
            } else if (parseInt(markArray[index]) < -1 || parseInt(markArray[index]) > 100) {
                toast.error(`Invalid Mark, Mark must be within -1 to 100 in Line ${index + 1}`);
                error = true;
            }

            if (contactHoursArray[index] === '') {
                toast.error(`Contact Hours required in Line ${index + 1}`);
                error = true;
            }

            if (attendenceArray[index] === '') {
                toast.error(`Attended Hours required in Line ${index + 1}`);
                error = true;
            } else if (parseInt(attendenceArray[index]) < 0 || parseInt(attendenceArray[index]) > parseInt(contactHoursArray[index])) {
                toast.error(`Attended.Hr must be within 0 to ${contactHoursArray[index]} in Line ${index + 1}`);
                error = true;
            }
        })

        const disciplineCoursId = getDisciplineCourseId(selectedDegreeId, selectedDisciplineId, selectedCourseId);

        const newAssessments = stuAssessmentTable.map((assessment, index) => ({
            registerNo: assessment.registerNo,
            degreeId: selectedDegreeId,
            disciplineId: selectedDisciplineId,
            disciplineCourseId: disciplineCoursId,
            batch: selectedBatchId,
            contactHours: contactHoursArray[index],
            attendedHours: attendenceArray[index],
            mark: markArray[index],
            phase: selectedPhaseId,
            // createdBy,
            // createTimestamp,
        }));

        if (!error) {
            api.post(`${apiUrl}/studentAssessment/`, newAssessments)
                .then((response) => {
                    if (response.status === 200) {

                        toast.success(response.data.message);
                        UpdateStudentMarksAsPerInternalsForAdd(exam, selectedDegreeId, selectedDisciplineId, selectedBatchId, sem, selectedCourseId)
                        fetchData(selectedDegreeId, selectedDisciplineId, selectedPhaseIdFilter, selectedBatchId, selectedCourseId);
                        // clearHandler();
                    }
                })
                .catch((error) => toast.error(error.response.data.message));
        }
    }

    const deleteHandler = (obj: StuAssessmentType) => {
        setId(obj.id);
        setEditRegisterNo(obj.registerNo);
        setEditDegreeId(obj.degreeId);
        setEditDegreeName(getDegreeName(obj.degreeId));
        setEditDisciplineId(obj.disciplineId);
        setEditDisciplineName(getDisciplineName(obj.disciplineId));
        setEditDisciplineCourseId(obj.disciplineCourseId);
        setEditCourse(getCourseId(obj));
        setCourseType(courseType)
        setSem(obj.semesterNo?.toString())
        setExam(obj.examId?.toString())
        setEditBatch(obj.batch);
        setEditContactHours(obj.contactHours);
        setEditAttendence(obj.attendedHours);
        setEditMark(obj.mark);
        setEditPhase(obj.phase);
        openDeleteConfirmation(); // Open the delete confirmation modal
    }

    const confirmDeleteHandler = () => {
        api.delete(`${apiUrl}/studentAssessment/?id=${id}`)
            .then((response) => {
                fetchData(degreeIdFilter, disciplineIdFilter, selectedPhaseIdFilter, batchFilter, selectedCourseIdFilter);
                UpdateStudentMarksAsPerInternalsForAssDlelete(exam, editDegreeId, editDisciplineId, editbatch, sem, editCourse, editRegisterNo)
                closeDeleteConfirmation();
                toast.success(response.data.message);
            })
            .catch((error) => {
                // console.log(error);
                toast.error(error.response.data.message, { position: 'top-right' });
            });
    };

    const openEditModel = (id: number, registerNo: string, degreeId: string, degreeName: string, disciplineId: string, disciplineName: string, disciplineCourseId: string, phase: string, course: string, batch: string, contactHours: string, attendedHours: string, mark: string, courseType: string, semesterNo: number, examId: number) => {

        setEditId(id);
        setEditRegisterNo(registerNo);
        setEditDegreeId(degreeId);
        setEditDegreeName(degreeName);
        setEditDisciplineId(disciplineId);
        setEditDisciplineName(disciplineName);
        setEditDisciplineCourseId(disciplineCourseId);
        setEditCourse(course);
        setCourseType(courseType)
        setSem(semesterNo?.toString())
        setExam(examId?.toString())
        setEditBatch(batch);
        setEditContactHours(contactHours);
        setEditAttendence(attendedHours);
        setEditMark(mark);
        setEditPhase(phase);
        setEditModelShow(true);
    }

    const saveEdit = () => {
        let error = false;

        if (editMark === '') {
            setMarkError('Mark required');
            error = true;
        } else if (parseInt(editMark) < -1 || parseInt(editMark) > 100) {
            setMarkError('Invalid Mark, Mark must be within -1 to 100');
            error = true;
        }

        if (editContactHours === '') {
            setContactHoursError('Contact Hours required');
            error = true;
        }

        if (editAttendence === '') {
            setAttendenceError('Attended Hours required');
            error = true;
        } else if (parseInt(editAttendence) < 0 || parseInt(editAttendence) > parseInt(editContactHours)) {
            setAttendenceError(`Attended.Hr must be within 0 to ${editContactHours}`);
            error = true;
        }

        const getDisciplineCourseId = (courseId: string) => {
            const selectedCourseIdInt = courseId;
            const course = courseList?.find((c) => c.name === selectedCourseIdInt);
            if (course) {
                const foundCourse = disciplineCourseList.find((disciplineCourse) => disciplineCourse.courseId === course.id);
                if (foundCourse) {
                    return foundCourse.id;
                }
            }
            return 'N/A';
        };

        const editData = {
            id: editId,
            registerNo: editRegisterNo,
            disciplineCourseId: getDisciplineCourseId(editCourse),
            contactHours: editContactHours,
            attendedHours: editAttendence,
            mark: editMark,
            phase: editPhase,

        }

        if (!error) {
            api.put(`${apiUrl}/studentAssessment/?id=${editId}`, editData)
                .then((response) => {
                    if (response.data.error) {
                        toast.error(response.data.message, { position: 'top-right' });
                        setApiErrorMessage(response.data.message);
                    } else {
                        if (response.status === 200) {
                            toast.success(response.data.message, { position: 'top-right' });
                            fetchData(degreeIdFilter, disciplineIdFilter, selectedPhaseIdFilter, batchFilter, selectedCourseIdFilter);
                            UpdateStudentMarksAsPerInternalsForAssEdit(exam, editDegreeId, editDisciplineId, editbatch, sem, editCourse, editRegisterNo);
                            setEditModelShow(false);
                            setMarkError('');
                            setAttendenceError('');
                            setContactHoursError('');
                        }
                    }
                })
                .catch((error) => {
                    console.error(error.response.data.message);
                });
        }

    }

    const clearHandler = () => {
        setId(0);
        setMarkError('');
        setEditFlag(false);
        setCourseType('');
        setSem('')
        setExam('')
        setSelectedDegreeId('');
        setSelectedDisciplineId('');
        setSelectedCourseId('');
        setSelectedPhaseId('');
        setSelectedBatchId('');
        setContactHours('');
        setDegreeIdError('');
        setDisciplineIdError('');
        setCourseIdError('');
        setPhaseIdError('');
        setBatchIdError('');
        setContactHoursError('');
        setAttendenceError('');
        setMarkArray([]);
        setAttendenceArray([]);
        setContactHoursArray([]);
        setStuAssessmentTable([]);
    };


    const openDeleteConfirmation = () => {
        setShowDeleteConfirmation(true);
    }

    const closeDeleteConfirmation = () => {
        setShowDeleteConfirmation(false);
    }

    const getCourseId = (disciplineCourseId: StuAssessmentType) => {
        const selectedCourseIdInt = parseInt(disciplineCourseId.disciplineCourseId);
        const course = disciplineCourseList?.find((c) => c.id === selectedCourseIdInt);

        if (course) {
            const foundCourse = courseList?.find((disciplineCourse) => disciplineCourse.id === course.courseId);
            if (foundCourse) {
                return foundCourse.name;
            }
        }

        return 'N/A';
    };


    const getPhaseId = (disciplineCourse: StuAssessmentType) => {
        const course = selectedPhase.find((disc) => disc.id === parseInt(disciplineCourse.phase));
        if (course) {
            return course.title;
        }
        return 'N/A';
    };

    const getUniqueBatch = () => {
        const uniqueBatch = Array.from(new Set(selectedBatch.map((batch) => batch.batch)));
        return uniqueBatch;
    };

    const getDegreeName = (degreeId: string) => {
        const degree = degreeList?.find((c) => c.id === parseInt(degreeId));
        if (degree) {
            return degree.name;
        }
        return 'N/A';
    }


    const getDisciplineName = (disciplineId: string) => {
        const discipline = disciplineList?.find((c) => c.id === parseInt(disciplineId));
        if (discipline) {
            return discipline.name;
        }
        return 'N/A';
    }

    const handleDownloadPDF = () => {
        const doc = new jsPDF('p', 'mm', 'a4');

        doc.addImage(imgPath, 'PNG', 25, 10, 170, 40);

        doc.setFontSize(16);
        doc.setFont('Arial', 'normal', 'bold');
        doc.setTextColor(0, 0, 0);
        doc.text('STUDENT ASSESSMENT', 110, 53, { align: 'center' });

        autoTable(doc, {
            startY: 60,
            margin: 3,
            headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineWidth: 0.3, lineColor: [0, 0, 0] },
            bodyStyles: { textColor: [0, 0, 0], lineColor: [0, 0, 0] },
            head: [
                [
                    { content: 'S.No.', styles: { halign: 'center', cellWidth: 10 } },
                    { content: 'Register No', styles: { halign: 'center', cellWidth: 25 } },
                    { content: 'Phase', styles: { halign: 'center', cellWidth: 23 } },
                    { content: 'Degree', styles: { halign: 'center', cellWidth: 20 } },
                    { content: 'Discipline', styles: { halign: 'center', cellWidth: 35 } },
                    { content: 'Discipline Course', styles: { halign: 'center', cellWidth: 25 } },
                    { content: 'Batch', styles: { halign: 'center', cellWidth: 13 } },
                    { content: 'Contact Hours', styles: { halign: 'center', cellWidth: 20 } },
                    { content: 'Attended Hours', styles: { halign: 'center', cellWidth: 20 } },
                    { content: 'Mark', styles: { halign: 'center', cellWidth: 12 } }
                ],
            ],
            body: studentListFilter.map((sl, index) => [
                { content: index + 1, styles: { halign: 'center' } },
                { content: sl.registerNo, styles: { halign: 'center' } },
                { content: getPhaseId(sl), styles: { halign: 'center' } },
                { content: getDegreeName(sl.degreeId), styles: { halign: 'center' } },
                { content: getDisciplineName(sl.disciplineId), styles: { halign: 'center' } },
                { content: getCourseId(sl), styles: { halign: 'center' } },
                { content: sl.batch, styles: { halign: 'center' } },
                { content: sl.contactHours, styles: { halign: 'center' } },
                { content: sl.attendedHours, styles: { halign: 'center' } },
                { content: sl.mark, styles: { halign: 'center' } },
            ]),
            theme: 'grid',
        });
        doc.save(fileName + '.pdf');
    }


    const csvData = [
        ['S.No',
            'Register No',
            'Phase',
            'Degree',
            'Discipline',
            'Discipline Course',
            'Batch',
            'Contact Hours',
            'Attended Hours',
            'Mark'
        ],

        ...studentListFilter.map((sl, i) => [
            i + 1,
            sl.registerNo,
            getPhaseId(sl),
            getDegreeName(sl.degreeId),
            getDisciplineName(sl.disciplineId),
            getCourseId(sl),
            sl.batch,
            sl.contactHours,
            sl.attendedHours,
            sl.mark

        ])

    ]

    // const handleDownloadPDF = () => {
    //     const doc = new jsPDF('p', 'mm', 'a4');

    //     doc.addImage(imgPath, 'PNG', 25, 10, 170, 40);

    //     doc.setFontSize(16);
    //     doc.setFont('Arial', 'normal', 'bold');
    //     doc.setTextColor(0, 0, 0);
    //     doc.text('DETAILS OF ASSESSMENT', 110, 53, { align: 'center' });

    //     const unwantedKeys = ["registerNo", "departmentRegisterNumber", "name"];

    //     const headers = Object.keys(stuAssessmentList[0]!)
    //         .filter(key => !unwantedKeys.includes(key))
    //         .map((key, index) => {
    //             const matchingCourse = CourseList.find(course => course.name === key);
    //             console.log(disciplineCourseList);
    //             if (matchingCourse) {
    //                 return { content: `${matchingCourse.shortName}`, colSpan: 1 };
    //             }
    //             return { content: `C${index + 1}`, colSpan: 1 };
    //         });

    //     const getPhaseId = (phaseId: string) => {
    //         const course = selectedPhase.find((e) => e.id === parseInt(phaseId));
    //         return course ? course.title : 'CONSOLIDATED MARKS';
    //     };

    //     const getDisciplineId = (phaseId: string) => {
    //         const course = selectedDiscipline.find((e) => e.id === parseInt(phaseId));
    //         return course ? course.name : 'N/A';
    //     };

    //     const totalColSpan = headers.reduce((acc, header) => acc + header.colSpan, 0);

    //     autoTable(doc, {
    //         startY: 65,
    //         headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], lineWidth: 0.3, lineColor: [0, 0, 0], fontSize: 7, valign: 'middle', halign: 'center' },
    //         bodyStyles: { textColor: [0, 0, 0], lineColor: [0, 0, 0], fontSize: 7, halign: 'center' },
    //         tableWidth: 200,
    //         margin: { left: 5, right: 5 },
    //         head: [
    //             [
    //                 { content: `AY: ${academicYearFilter} `, colSpan: 2, styles: { halign: "center" } },
    //                 { content: `SEM.: ${semester} `, styles: { halign: "center" } },
    //                 { content: `DISCIPLINE: ` + getDisciplineId(disciplineIdFilter), colSpan: 1, styles: { halign: "center" } },
    //                 { content: getPhaseId(selectedPhaseId), colSpan: totalColSpan, styles: { halign: "center" } },
    //             ],
    //             [
    //                 { content: "S.No.", styles: { halign: "center" } },
    //                 { content: "Reg.No.", styles: { halign: "center" } },
    //                 { content: "D.No.", styles: { halign: "center" } },
    //                 { content: "Name of the student ", colSpan: 1, styles: { halign: "center", cellWidth: 5 } },
    //                 ...headers,
    //             ],
    //         ],
    //         body: studentListFilter.map((row, index) => {
    //             const cellContents = Object.keys(row).map(key => (
    //                 !unwantedKeys.includes(key) && { content: row[key] !== null ? row[key].toString() : "-" }
    //             )).filter(Boolean);

    //             return [
    //                 { content: index + 1, styles: { halign: 'center' } },
    //                 { content: row.registerNo, styles: { halign: 'center' } },
    //                 { content: row.departmentRegisterNumber, styles: { halign: 'center' } },
    //                 { content: row.name, styles: { halign: 'left' } },
    //                 ...cellContents,
    //             ];
    //         }),
    //         theme: 'grid',
    //         columnStyles: {
    //             0: { cellWidth: 10 },
    //             1: { cellWidth: 22 },
    //             2: { cellWidth: 11 },
    //             3: { cellWidth: 33 },
    //         },
    //     });

    //     autoTable(doc, {
    //         didDrawPage: (data) => {
    //             doc.setFontSize(9);
    //             doc.setFont('Arial', 'normal', 'bold');
    //             doc.setTextColor(0, 0, 0);
    //             let yPos = (doc as any).lastAutoTable.finalY + 10;
    //             const displayedKeys: any = [];
    //             let displayedKeysCount = 0;

    //             const columns: { header: string, dataKey: string }[] = [];


    //             const headers = Object.keys(stuAssessmentList[0])
    //                 .filter(key => !unwantedKeys.includes(key))
    //                 .map((key, index) => {
    //                     if (key !== "registerNo" && key !== "departmentRegisterNumber" && key !== "name" && !displayedKeys.includes(key)) {
    //                         const matchingCourse = CourseList.find(course => course.name === key);

    //                         if (matchingCourse) {
    //                             columns.push({ header: `${matchingCourse.shortName} - ${key}`, dataKey: key });
    //                             displayedKeys.push(key);
    //                             displayedKeysCount++;
    //                         }
    //                     }
    //                 });

    //             autoTable(doc, {
    //                 startY: yPos,
    //                 headStyles: { fillColor: [255, 255, 255], textColor: [0, 0, 0], fontSize: 8, },
    //                 bodyStyles: { textColor: [0, 0, 0], lineColor: [0, 0, 0], fontSize: 8 },
    //                 head: columns.map(col => [col.header]),
    //                 // body: rows,
    //                 theme: 'plain',
    //             });
    //         }
    //     });

    //     doc.save(fileName + '.pdf');
    // }


    // const csvData = stuAssessmentList.map((row, index) => {
    //     const cellContents = Object.keys(row)
    //         .filter((key) => !unwantedKeys.includes(key))
    //         .map((key) => (row[key] !== null ? row[key].toString() : "-"));

    //     // Create a row for each student
    //     const rowData = [
    //         index + 1,
    //         row["register_no"],
    //         row["department_register_number"],
    //         row["name"],
    //         ...cellContents,
    //     ];

    //     return rowData;
    // });

    // // Add header row to csvData
    // const headerRow = [
    //     'S.No', 'Reg.No', 'D.No.', 'Name of the student',
    //     ...headers,
    // ];

    // csvData.unshift(headerRow);


    return (
        <PageContainer title="Student Assessment">
            <Card title="Add Student Assessment">
                <div className='container m-0'>
                    <div className="row">

                        <div className="col-4">
                            <label className="mt-3 mb-3">Degree <span className="text-danger">*</span> : </label>
                            <select
                                className="form-control"
                                style={{ width: "100%", marginRight: "20px" }}
                                name="selectedDegree"
                                value={selectedDegreeId}
                                onChange={(e) => setSelectedDegreeId(e.target.value)}
                            >
                                <option value="" selected>Select Degree</option>
                                {degreeList?.map((course) => (
                                    <option key={course.id} value={course.id}>
                                        {course.name}
                                    </option>
                                ))}
                            </select>
                            {degreeIdError && <div className="text-danger">{degreeIdError}</div>}
                        </div>

                        <div className="col-4">
                            <label className="mt-3 mb-3">Discipline <span className="text-danger">*</span> : </label>
                            <select
                                className="form-control"
                                style={{ width: "100%", marginRight: "20px", }}
                                name="selectedDiscipline"
                                value={selectedDisciplineId}
                                onChange={(e) => setSelectedDisciplineId(e.target.value)}
                            >
                                <option value="" selected>Select Discipline</option>
                                {disciplineList?.map((course) => (
                                    <option key={course.id} value={course.id}>
                                        {course.name}
                                    </option>
                                ))}
                            </select>
                            {disciplineIdError && <div className="text-danger">{disciplineIdError}</div>}
                        </div>

                        <div className="col-4">
                            <label className="mt-3 mb-3">Course <span className="text-danger">*</span> : </label>
                            <select
                                className="form-control"
                                style={{ width: "100%", marginRight: "20px" }}
                                name="selectedCourse"
                                value={selectedCourseId}
                                onChange={(e) => setSelectedCourseId(e.target.value)}
                            >
                                <option value="" selected>Select Course</option>
                                {courseList?.map((course) => (
                                    <option key={course.id} value={course.id}>
                                        {course.name}
                                    </option>
                                ))}
                            </select>
                            {courseIdError && <div className="text-danger">{courseIdError}</div>}
                        </div>

                        <div className="col-sm-6 col-md-4 col-lg-4">
                            <label className="mt-3 mb-3">Course Type <span className="text-danger">*</span> : </label>
                            <select
                                className="form-control"
                                name="CourseHead"
                                onChange={(e) => {
                                    setCourseType(e.target.value);
                                    setCourseTypeError('');
                                    setApiErrorMessage('');
                                }}
                                value={courseType}
                            >
                                <option value="">Select Course Type</option>
                                {dropDownList?.filter(dl => dl.category === 'Course Type').map((dd) => {
                                    return <option value={dd.title} key={dd.id}>{dd.title}</option>
                                })
                                }

                            </select>
                            {courseTypeError && <div className="text-danger">{courseTypeError}</div>}
                        </div>

                        <div className="col-4">
                            <label className="mt-3 mb-3">Phase <span className="text-danger">*</span> : </label>
                            <select
                                className="form-control"
                                style={{ width: "100%", marginRight: "20px" }}
                                name="selectedPhase"
                                value={selectedPhaseId}
                                onChange={(e) => setSelectedPhaseId(e.target.value)}
                            >
                                <option value="" selected>Select Phase</option>
                                {/* <option value="0">All Phase</option> */}
                                {selectedPhase.map((course) => (
                                    <option key={course.id} value={course.id}>
                                        {course.title}
                                    </option>
                                ))}
                            </select>
                            {phaseIdError && <div className="text-danger">{phaseIdError}</div>}
                        </div>

                        <div className="col-4">
                            <label className="mt-3 mb-3">Batch <span className="text-danger">*</span> : </label>
                            <select
                                className="form-control"
                                style={{ width: "100%", marginRight: "20px" }}
                                name="selectedBatch"
                                value={selectedBatchId}
                                onChange={(e) => setSelectedBatchId(e.target.value)}
                            >
                                <option value="" selected>Select Batch</option>
                                {last10Years.map((year) => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </select>
                            {batchIdError && <div className="text-danger">{batchIdError}</div>}
                        </div>

                        <div className="col-4">
                            <label className="mt-3 mb-3">Actual Contact Hours <span className="text-danger">*</span> : </label>
                            <input className="form-control" placeholder="Enter Contact Hours..." type="text" name="ContactHours" onChange={(e) => {
                                setContactHours(e.target.value);
                                setContactHoursError('');
                                setApiErrorMessage('');
                            }} value={contactHours} />
                            {contactHoursError && <div className="text-danger">{contactHoursError}</div>}
                        </div>

                        <div className='col-sm-6 col-md-4 col-lg-4'>
                            <label className="mt-3 mb-2" htmlFor="examId">Exam <span className="text-danger">*</span> : </label>
                            <select
                                className="form-control"
                                name="examIdFilter"
                                value={exam}
                                onChange={(e) => {
                                    setExam(e.target.value)
                                    setExamError('')
                                }}
                            >
                                <option value="" selected>Select</option>
                                {examList.map((el) => (
                                    <option key={el.id} value={el.id}>
                                        {el.title}
                                    </option>
                                ))}
                            </select>
                            {/* <FormInput
                                label='Exam'
                                name='Exam'
                                labelClassName="required"
                                type='select'
                                containerClass="mt-3 mb-3"
                                value={exam}
                                onChange={(e) => {
                                    setExam(e.target.value)
                                    setExamError('')
                                }}
                                errorText={examError}
                            >
                                <Option value=''>Select</Option>
                                {examList?.map((e, i) => {
                                    return <Option value={e.id} key={i}>{e.title}</Option>
                                })}
                            </FormInput> */}
                        </div>

                        <div className="col-sm-6 col-md-4 col-lg-4">
                            <FormInput
                                name="Sem"
                                label="Sem"
                                labelClassName="required"
                                value={sem}
                                onChange={(e) => {
                                    setSem(e.target.value)
                                    setSemError('')
                                }}
                                placeholder="Select Sem"
                                containerClass="mt-3 mb-3"
                                type="select"
                                errorText={semError}
                            >
                                <option value="">Select Semester</option>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                            </FormInput>

                        </div>

                        <div className="col-12">
                            <button
                                type="button"
                                className="btn btn-sm btn-primary"
                                onClick={filterStudent}
                                style={{ width: "10%", marginTop: "30px", marginBottom: "30px", float: "right" }}
                            >
                                Search
                            </button>
                        </div>
                    </div>
                </div>
                <div className="container-fluid" style={{ width: "100%", marginTop: "20px" }}>
                    <table className="table table-success table-striped">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Register No</th>
                                {/* <th>Phase</th> */}
                                <th>Contact Hours <span className="text-danger">*</span></th>
                                <th>Attended Hours <span className="text-danger">*</span></th>
                                <th>Mark <span className="text-danger">*</span></th>
                            </tr>
                        </thead>
                        <tbody>
                            {stuAssessmentTable?.map((StuAssessment, index) => (
                                <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{StuAssessment.registerNo}</td>
                                    {/* <td>{StuAssessment.phase}</td> */}
                                    <td>
                                        <input
                                            className="form-control"
                                            placeholder="Enter Contact Hours..."
                                            type="number"
                                            name={`contactHours-${index}`}
                                            onChange={(e) => handelContactHoursChange(index, e.target.value)}
                                            value={contactHoursArray[index]}
                                            style={{ width: '60%' }}

                                        />
                                        {contactHoursError && <div className="text-danger">{contactHoursError}</div>}
                                    </td>
                                    <td>
                                        <input
                                            className="form-control"
                                            placeholder="Enter Attendance Hour..."
                                            type="number"
                                            name={`attendence-${index}`}
                                            onChange={(e) => handelAttendenceChange(index, e.target.value)}
                                            value={attendenceArray[index]} style={{ width: "60%" }}
                                        />
                                        {attendenceError && <div className="text-danger">{attendenceError}</div>}
                                    </td>
                                    <td>
                                        <input
                                            className="form-control"
                                            placeholder="Enter Mark..."
                                            type="number"
                                            name={`mark-${index}`}
                                            onChange={(e) => handleMarkChange(index, e.target.value)}
                                            value={markArray[index] || ''} style={{ width: "60%" }}
                                        />
                                        {markError && <div className="text-danger">{markError}</div>}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
                <div className="col d-flex justify-content-end" style={{ width: "95%" }}>
                    <button className="btn btn-sm btn-secondary" onClick={clearHandler} style={{ marginRight: '10px' }}>
                        Clear
                    </button>
                    {/* {editFlag ? <button className="btn btn-success" onClick={updateHandler}>Update</button> : */}
                    <button className="btn btn-sm btn-success" onClick={addHandler}>Add</button>
                </div>
            </Card>

            <CollapseCard title="Student Assessment">
                <div className="row m-2 mb-3">

                    {/* <div className="col-4">
                        <label className="">Academic Year  : </label>
                        <select
                            className="form-control"
                            style={{ width: "100%", marginRight: "20px" }}
                            name="academicYearFilter"
                            value={academicYearFilter}
                            onChange={(e) => setAcademicYearFilter(e.target.value)}
                        >
                            {academicYearOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div> */}

                    {/* <div className="col-4">
                        <label className="">Semester  : </label>
                        <select
                            className="form-control"
                            style={{ width: "100%", marginRight: "20px" }}
                            name="selectedBatch"
                            value={semester}
                            onChange={(e) => setSemester(e.target.value)}
                        >
                            <option value="" selected>Select Semester</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                        </select>
                    </div> */}

                    <div className="col-4">
                        <label className="">Phase <span className="text-danger">*</span> : </label>
                        <select
                            className="form-control"
                            style={{ width: "100%", marginRight: "20px" }}
                            name="selectedPhase"
                            value={selectedPhaseIdFilter}
                            onChange={(e) => setSelectedPhaseIdFilter(e.target.value)}
                        >
                            <option value="" selected>Select Phase</option>
                            {/* <option value="0">All Phase</option> */}
                            {selectedPhase.map((course) => (
                                <option key={course.id} value={course.id}>
                                    {course.title}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-4">
                        <label className="mt-2 mb-2">degree <span className="text-danger">*</span> : </label>
                        <select
                            className="form-control"
                            style={{ width: "100%", marginRight: "20px" }}
                            name="degreeId"
                            value={degreeIdFilter}
                            onChange={(e) => setDegreeIdFilter(e.target.value)}
                        >
                            <option value="" selected>Select Degree</option>
                            {degreeList?.map((deg) => (
                                <option key={deg.id} value={deg.id}>
                                    {deg.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-4">
                        <label className="mt-2 mb-2">discipline <span className="text-danger">*</span> : </label>
                        <select
                            className="form-control"
                            style={{ width: "100%", marginRight: "20px" }}
                            name="disciplineId"
                            value={disciplineIdFilter}
                            onChange={(e) => setDisciplineIdFilter(e.target.value)}
                        >
                            <option value="" selected>Select Discipline</option>
                            {disciplineList?.map((dis) => (
                                <option key={dis.id} value={dis.id}>
                                    {dis.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-4">
                        <label className="mt-2 mb-2">Course <span className="text-danger">*</span> : </label>
                        <select
                            className="form-control"
                            style={{ width: "100%", marginRight: "20px" }}
                            name="selectedCourseFilterId"
                            value={selectedCourseIdFilter}
                            onChange={(e) => setSelectedCourseIdFilter(e.target.value)}
                        >
                            <option value="" selected>Select Course</option>
                            {courseList?.map((dis) => (
                                <option key={dis.id} value={dis.id}>
                                    {dis.name}
                                </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-4">
                        <label className="mt-2 mb-2">batch <span className="text-danger">*</span> : </label>
                        <select name="" id="" className='form-control' value={batchFilter} onChange={(e) => {
                            setBatchFilter(e.target.value)
                        }}>
                            <option value="">Select Batch</option>
                            {last10Years.map((ly => {
                                return <option key={ly} value={ly}>{ly}</option>
                            }))}
                        </select>
                    </div>
                    {/* <div className="col-4">
                        <button
                            type="button"
                            className="className='btn btn-sm btn-primary mt-5 mb-3"
                            onClick={fetchData}
                        >
                            Search
                        </button>
                    </div> */}

                    <div className="mt-1 mb-1 d-flex justify-content-end">
                        <button
                            type="button"
                            className="btn btn-sm btn-primary mt-5 mb-3"
                            style={{ marginRight: '10px' }}
                            onClick={() => fetchData(degreeIdFilter, disciplineIdFilter, selectedPhaseIdFilter, batchFilter, selectedCourseIdFilter)}
                        >
                            Search
                        </button>

                        <button
                            type="button"
                            className="btn btn-sm btn-secondary mt-5 mb-3"
                            onClick={resetData}
                        >Reset
                        </button>
                    </div>
                </div>

                <div style={{ margin: '0% 5% 3% 0%', float: 'right' }}>
                    <button
                        type="button"
                        onClick={handleDownloadPDF}
                        className="m-1 btn btn-sm btn-primary"
                    >
                        <Feather.Download /> PDF
                    </button>
                    <CSVLink
                        data={csvData}
                        filename="details_of_course.csv"
                        className=" btn btn-sm btn-primary"
                    >
                        <Feather.Download /> CSV
                    </CSVLink>
                </div>

                <div className="container-fluid" style={{ width: "100%" }}>
                    <table className="table table-success table-striped">
                        <thead>
                            <tr>
                                <th>S.No</th>
                                {/* <th>ID</th> */}
                                <th>Register No</th>
                                <th>Phase</th>
                                <th>Degree</th>
                                <th>Discipline</th>
                                <th>Discipline Course </th>
                                <th>Course Type</th>
                                <th>Batch</th>
                                <th>Contact Hours</th>
                                <th>Attended Hours</th>
                                <th>Mark</th>
                                {/* <th>Created By</th>
              <th>Create Timestamp</th> */}
                                <th>Options</th>
                            </tr>
                        </thead>
                        <tbody>
                            {studentListFilter.sort((a, b) => parseInt(a.registerNo) - parseInt(b.registerNo))?.map((sl, index) => (

                                <tr key={sl.id}>
                                    <td>{index + 1}</td>
                                    {/* <td>{sl.id}</td> */}
                                    <td>{sl.registerNo}</td>
                                    <td>{getPhaseId(sl)}</td>
                                    <td>{getDegreeName(sl.degreeId)}</td>
                                    <td>{getDisciplineName(sl.disciplineId)}</td>
                                    <td>{getCourseId(sl)}</td>
                                    <td>{sl.courseType}</td>
                                    <td>{sl.batch}</td>
                                    <td>{sl.contactHours}</td>
                                    <td>{sl.attendedHours}</td>
                                    <td>{sl.mark}</td>
                                    {/* <td>{sl.createdBy}</td>
                <td>{sl.createTimestamp}</td> */}
                                    <td>
                                        <button className="btn btn-sm btn-primary" style={{ marginRight: '10px' }} onClick={() => openEditModel(sl.id,
                                            sl.registerNo,
                                            sl.degreeId,
                                            getDegreeName(sl.degreeId),
                                            sl.disciplineId,
                                            getDisciplineName(sl.disciplineId),
                                            sl.disciplineCourseId,
                                            sl.phase,
                                            getCourseId(sl),
                                            sl.batch,
                                            sl.contactHours,
                                            sl.attendedHours,
                                            sl.mark,
                                            sl.courseType,
                                            sl.semesterNo, sl.examId)}>Edit</button>
                                        <button className="btn btn-sm btn-danger" onClick={() => deleteHandler(sl)}>Delete</button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </CollapseCard>
            <Modal show={editModelShow} onHide={() => setEditModelShow(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Student Assessment</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        <div className="col-6">
                            <label className="mt-3 mb-3">Register No:</label>
                            <input className="form-control" type="text" value={editRegisterNo} readOnly />
                        </div>

                        <div className="col-6">
                            <label className="mt-3 mb-3">Degree:</label>
                            <input className="form-control" type="text" value={editDegreeName} readOnly />
                        </div>

                        <div className="col-6">
                            <label className="mt-3 mb-3">Discipline:</label>
                            <input className="form-control" type="text" value={editDisciplineName} readOnly />
                        </div>

                        <div className="col-6">
                            <label className="mt-3 mb-3">Course:</label>
                            <input className="form-control" type="text" value={editCourse} readOnly />
                        </div>

                        <div className="col-6">
                            <label className="mt-3 mb-3">Phase:</label>
                            <select
                                className="form-control"
                                // style={{ width: "100%", marginRight: "20px" }}
                                name="selectedPhase"
                                value={editPhase}
                                onChange={(e) => setSelectedPhaseId(e.target.value)}
                                disabled
                            >
                                <option value="" selected>Select Phase</option>
                                {/* <option value="0">All Phase</option> */}
                                {selectedPhase.map((phase) => (
                                    <option key={phase.id} value={phase.id}>
                                        {phase.title}
                                    </option>
                                ))}
                            </select>
                        </div>

                        <div className="col-6">
                            <label className="mt-3 mb-3">Batch:</label>
                            <input className="form-control" type="text" value={editbatch} readOnly />
                        </div>

                        <div className="col-6">
                            <label className="mt-3 mb-3">Actual Contact Hours <span className="text-danger">*</span> : </label>
                            <input className="form-control" placeholder="Enter Contact Hours..." type="text" name="ContactHours" onChange={(e) => {
                                setEditContactHours(e.target.value);
                                setContactHoursError('');
                            }} value={editContactHours} />
                            {contactHoursError && <div className="text-danger">{contactHoursError}</div>}
                        </div>

                        <div className="col-6">
                            <label className="mt-3 mb-3">Attendance Hour <span className="text-danger">*</span> : </label>
                            <input
                                className="form-control"
                                placeholder="Enter Attendance Hour..."
                                type="number"
                                name="Mark"
                                onChange={(e) => {
                                    setEditAttendence(e.target.value);
                                    setAttendenceError('');
                                }}
                                value={editAttendence}
                            />
                            {attendenceError && <div className="text-danger">{attendenceError}</div>}
                        </div>

                        <div className="col-6">
                            <label className="mt-3 mb-3">Mark <span className="text-danger">*</span> : </label>
                            <input
                                className="form-control"
                                placeholder="Enter Mark..."
                                type="number"
                                name="Mark"
                                onChange={(e) => {
                                    setEditMark(e.target.value);
                                    setMarkError('');
                                }}
                                value={editMark}
                            />
                            {markError && <div className="text-danger">{markError}</div>}
                        </div>
                    </div>

                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setEditModelShow(false)}>
                        Close
                    </Button>
                    <Button variant="primary" onClick={saveEdit}>
                        Save
                    </Button>
                </Modal.Footer>
            </Modal>
            {/* Deletion Confirmation Modal */}
            <Modal show={showDeleteConfirmation} onHide={closeDeleteConfirmation}>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Deletion</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to delete this item?
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={closeDeleteConfirmation}>
                        Cancel
                    </Button>
                    <Button variant="danger" onClick={confirmDeleteHandler}>
                        Delete
                    </Button>
                </Modal.Footer>
            </Modal>
        </PageContainer>
    );
}

export default StuAssessment;

interface StuAssessmentType {
    id: number;
    registerNo: string;
    degreeId: string;
    disciplineId: string;
    disciplineCourseId: string;
    semesterNo: number;
    examId: number;
    courseType: string;
    batch: string;
    mark: string;
    externalMaxMark: string;
    createdBy: string;
    createTimestamp: string;
    phase: string;
    contactHours: string;
    attendedHours: string;
}

interface StuAssessmentUpdateType {
    registerNo: string;
    contactHours?: string;
    attendedHours?: string;
    mark?: string;
    externalMaxMark: string;

}
